<template>
    <div class="jobDetailsMain" :class="$IsMobile ? 'moblie' : ''">
        <div class="jobTit">
            <div class="container clearfix">
                <div class="mianInfo fl">
                    <h3 class="pos txtCutter">{{ baseInfo.positionName }}</h3>
                    <div class="salary">薪酬：{{ salaryFormatter(baseInfo) }}</div>
                    <div class="require txtCutter">
                        <span v-if="dictFormatter(willNatureOptions, baseInfo.willNature)"> {{ dictFormatter(willNatureOptions, baseInfo.willNature) }} </span>
                        <span v-if=" dictFormatter( educationOptions, baseInfo.educationalRequirements ) "> {{ dictFormatter( educationOptions, baseInfo.educationalRequirements ) }} </span>
                        <span v-if="baseInfo.exp">{{ baseInfo.exp }}</span>
                        <span v-if="countFormatter(baseInfo)">{{ countFormatter(baseInfo) }}人</span>
                    </div>
                    <div class="dateTime" v-if="$IsMobile">
                        <p v-if="baseInfo && baseInfo.updateTime"> {{ dateFormatter(baseInfo.updateTime) }}<em></em>
                            {{ timeFormatter(baseInfo.updateTime) }}<em></em>职位更新
                        </p>
                        <p v-else-if="baseInfo && baseInfo.publishTime">
                            {{ dateFormatter(baseInfo.publishTime) }}<em></em>
                            {{ timeFormatter(baseInfo.publishTime) }}<em></em>职位发布
                        </p>

                        <p v-if="baseInfo && baseInfo.deadline">
                            {{ dateFormatter(baseInfo.deadline) }}<em></em>
                            {{ timeFormatter(baseInfo.deadline) }}<em></em>投递截止
                        </p>
                    </div>
                </div>
                <div class="sideInfo fr" v-if="baseInfo && baseInfo.id">
                    <el-row :gutter="15">
                        <el-col :span="$IsMobile ? 12 : 10">
                            <el-button round type="primary" icon="el-icon-star-on" style="width: 100%"
                                       v-if="checkCollection" @click="cancelJobCollection(jobId)"
                                       v-has-permi="['enterprise:collect:delete']">
                                已收藏
                            </el-button>
                            <el-button round style="width: 100%" type="primary" icon="el-icon-star-off"
                                       v-else @click="jobCollection(jobId)"
                                       v-has-permi="['enterprise:collect:add']">收 藏
                            </el-button>
                        </el-col>
                        <el-col :span="$IsMobile ? 12 : 14"
                                v-if=" baseInfo
                                &&  (baseInfo.status == CLOSE || (baseInfo.status == ISSUED
                                && hasBeenPosting == false && !isEnd(baseInfo.deadline))
                                || (baseInfo.status == ISSUED && hasBeenPosting)) ">
                            <el-button round style="width: 100%" type="primary"
                                       v-if="baseInfo && baseInfo.status == CLOSE">
                                职位已下线
                            </el-button>
                            <el-button round style="width: 100%" type="primary"
                                       icon="el-icon-s-promotion"
                                       v-else-if="baseInfo && baseInfo.status == ISSUED && hasBeenPosting == false && !isEnd(baseInfo.deadline)"
                                       @click="handlePush"
                                       v-has-permi="['resume:delivery:add']">
                                投递简历
                            </el-button>
                            <el-button round style="width: 100%" :disabled="false" type="primary"
                                       icon="el-icon-s-promotion"
                                       v-else-if="baseInfo && baseInfo.status == ISSUED && hasBeenPosting"
                                       @click="handlePush">
                                投递成功
                            </el-button>
                        </el-col>
                    </el-row>
                    <div class="dateTime">
                        <p v-if="baseInfo && baseInfo.updateTime">
                            {{ dateFormatter(baseInfo.updateTime) }}
                            <em></em>
                            {{ timeFormatter(baseInfo.updateTime) }}
                            <em></em>
                            职位更新
                        </p>
                        <p v-else-if="baseInfo && baseInfo.publishTime">
                            {{ dateFormatter(baseInfo.publishTime) }}
                            <em></em>
                            {{ timeFormatter(baseInfo.publishTime) }}
                            <em></em>
                            职位发布
                        </p>

                        <p v-if="baseInfo && baseInfo.deadline">
                            {{ dateFormatter(baseInfo.deadline) }}
                            <em></em>
                            {{ timeFormatter(baseInfo.deadline) }}
                            <em></em>
                            投递截止
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container ptb25">
            <!-- 职位已经下线-->
            <div class="jobContent clearfix" v-if="baseInfo && baseInfo.status == CLOSE">
                <div class="img">
                    <img src="@/pages/frontend/assets/images/industry-2.jpg"/>
                </div>
            </div>
            <div class="jobContent clearfix" v-else>
                <div class="jobDes fl">
                    <div class="cBlock">
                        <div class="tit" v-if="baseInfo.keywordList">
                            <h5>职位关键词</h5>
                        </div>
                        <div class="cTxt">
                            <div class="label">
                                <span style="height: auto" v-for="(item, index) in baseInfo.keywordList"
                                      :key="index">{{ item.labelName }}</span>
                            </div>
                        </div>
                        <div class="tit" v-if="baseInfo.skillsList"><h5>技能要求</h5></div>
                        <div class="cTxt">
                            <div class="label">
                                <span style="height: auto" v-for="(item, index) in baseInfo.skillsList"
                                      :key="index">{{ item.labelName }}</span>
                            </div>
                        </div>
                        <div class="tit"><h5>职位描述</h5></div>
                        <div class="cTxt">
                            <div class="ql-container ql-snow">
                                <div class="ql-editor">
                                    <div class="details_box" v-html="baseInfo.jobRequiredments"></div>
                                </div>
                            </div>
                        </div>
                        <div class="tit" v-if="welfareJson"><h5>职位福利</h5></div>
                        <div class="cTxt">
                            <div class="label">
                                <span style="height: auto" v-for="(welfare, w) in welfareJson" :key="w">{{ welfare }}</span>
                            </div>
                        </div>
                        <div class="tit"><h5>工作地点</h5></div>
                        <div class="cTxt">
                            <p>{{ workplaceFormatter(baseInfo) }}</p>
                        </div>
                    </div>
                </div>
                <div class="compangDes fr">
                    <div class="cBlock">
                        <div class="tit"><h5>公司简介</h5></div>
                        <div class="cTxt">
                            <div class="companyIntro" v-if="enterpriseInfo">
                                <div class="logoName" @click="handleCompany" style="cursor: pointer">
                                    <div class="logo">
                                        <img :src="logoHandle(enterpriseInfo.logo)" v-if="enterpriseInfo.logo"/>
                                        <img src="@/pages/frontend/assets/images/company.jpg" v-else/>
                                    </div>
                                    <div class="name">
                                        <span>{{ enterpriseInfo.shortName }}</span>
                                    </div>
                                </div>
                                <div class="slogan" v-if="enterpriseInfo.slogan">
                                    {{ enterpriseInfo.slogan }}
                                </div>
                                <div class="property">
                                    <p v-if="enterpriseInfo.industry">
                                        <i class="icons-sort"></i>
                                        {{ tagArrayToStr(enterpriseInfo.industry, "/") }}
                                    </p>
                                    <p v-if="enterpriseInfo.econKind">
                                        <i class="icons-label"></i>{{ enterpriseInfo.econKind }}
                                    </p>
                                    <p v-if="enterpriseInfo.personScope">
                                        <i class="icons-users"></i>{{ enterpriseInfo.personScope }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cBlock mt25" v-if="baseInfo.publisherName">
                        <div class="tit"><h5>职位发布者</h5></div>
                        <div class="cTxt">
                            <div class="hr">
                                <div class="img">
                                    <img src="@/pages/frontend/assets/images/defaultHeadIcons.png"/>
                                </div>
                                <div class="name">
                                    <h5 class="txtCutter">{{ baseInfo.publisherName }}</h5>
                                    <p>HR</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="投递简历" :visible.sync="submitResumeDialog" width="460px" custom-class="submit-resume"
                   heigth="240px" :before-close="closeSubmitResumeDialog">
            <el-form label-width="80px" ref="submitResumeForm" :rules="rules" :model="form">
                <el-form-item label="选择简历" prop="resumeId">
                    <el-select :popper-append-to-body="!$IsMobile" v-model="form.resumeId" clearable placeholder="请选择">
                        <el-option v-for="item in resumeList" :key="item.id" :label="item.resumeName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-has-permi="['resume:info:default']">
                    <el-checkbox v-model="form.defaultFlag">默认选择此简历</el-checkbox>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitResume('submitResumeForm')">立即投递</el-button>
                <el-button @click="closeSubmitResumeDialog">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import moment from "moment";
    import {checkUserIdIsInJobPositionApplyRecord, queryData, queryPublisherInfo,} from "@/api/job";
    import {getInfoExtByEnterpriseId} from "@/api/enterprise";
    import {getBaseInfoListByCreatorId, updateResumeDefaultFlag,} from "@/api/resume";
    import {addMyJobPositionApplyRecord} from "@/api/myJobApply";
    import {saveResumeDeliveryRecord} from "@/api/resumeDeliveryRecord";
    import {cancelJobCollection, checkJobPositionCollection, saveJobCollection,} from "@/api/jobCollection";
    import {getTreeListByDictType} from "@/api/dict";
    import {editorOption} from '@/utils/quill-editor-option'

    const ISSUED = 1; // 已发布
    const CLOSE = 2; // 已关闭
    const YEAR_WAGES = 0; // 年薪
    const MONTHLY_WAGES = 1; // 月薪
    const DAILY_WAGES = 2; // 日薪
    const HOURLY_WAGES = 3; // 时薪
    const FACE_TO_FACE_WAGES = 4;     // 面议
    export default {
        name: "jobDetails",
        data() {
            return {
                ISSUED: ISSUED,
                CLOSE: CLOSE,
                loading: false,
                // 登录url路径
                loginUrl: "/login",
                jobId: undefined,
                baseInfo: {},
                enterpriseInfo: {},
                hasBeenPosting: false,
                publisher: {},
                submitResumeDialog: false, // 投递简历弹窗
                resumeList: [], // 简历列表
                form: {},
                defaultFlagForm: {
                    resumeId: undefined, // 选择的简历id
                    defaultFlag: false, // 选择默认简历
                },
                rules: {
                    // 投递简历校验规则
                    resumeId: [
                        {required: true, message: "请选择一份简历", trigger: "change"},
                    ],
                },
                checkCollection: false, // 默认未收藏
                willNatureOptions: [], // 工作性质
                educationOptions: [], // 学历要求
                //编辑器配置项
                editorOption: editorOption
            };
        },
        created() {
            this.loadDictData();
            if (this.$route.params && this.$route.params.jobId) {
                let jobId = this.$route.params.jobId;
                this.jobId = jobId;
                this.queryBaseInfo(jobId);
                if (this.Cookies.get("TipDM-Login-Token")) {
                    this.checkJobCollection(jobId);
                    this.checkUserIdIsInJobPositionApplyRecord(jobId);
                } else {
                    window.localStorage.clear();
                }
            }
        },
        computed: {
            // 福利
            welfareJson() {
                if (!this.baseInfo || !this.baseInfo.welfare) {
                    return null;
                }
                return JSON.parse(this.baseInfo.welfare);
            },
            logoHandle() {
                return function (file) {
                    let imagePath = encodeURI(file);
                    return `/files?imagePath=${imagePath}`;
                };
            },
        },
        methods: {
            handleCompany() {
                if (process.env.NODE_ENV == "development") {
                    window.open(
                        window.location.origin +
                        "/frontend#/companyDetails/" +
                        this.enterpriseInfo.enterpriseId
                    );
                } else {
                    window.open(
                        window.location.origin +
                        "/#/companyDetails/" +
                        this.enterpriseInfo.enterpriseId
                    );
                }
            },
            loadDictData() {
                getTreeListByDictType("work_nature").then((response) => {
                    this.willNatureOptions = response.data;
                });
                getTreeListByDictType("education_requirement").then((response) => {
                    this.educationOptions = response.data;
                });
            },
            /** 检查职位是否被收藏*/
            checkJobCollection(jobId) {
                checkJobPositionCollection(jobId).then((res) => {
                    this.checkCollection = res.data;
                });
            },
            /** 取消职位收藏*/
            cancelJobCollection(jobId) {
                cancelJobCollection(jobId).then((res) => {
                    this.checkCollection = false;
                });
            },
            /** 收藏职位*/
            jobCollection(jobId) {
                if (!this.Cookies.get("TipDM-Login-Token")) {
                    // 跳转到登录页面
                    window.location.href = this.loginUrl;
                } else {
                    saveJobCollection(jobId).then((res) => {
                        this.checkCollection = true;
                    });
                }
            },
            /** 查询职位基础信息*/
            queryBaseInfo(jobId) {
                queryData({id: jobId}).then((res) => {
                    if (res.status == 200 && res.data) {
                        this.baseInfo = res.data;
                        if (res.data.enterpriseId) {
                            // 查询企业信息
                            this.queryEnterpriseInfo();
                        }
                    }
                });
            },
            /** 查询企业信息*/
            queryEnterpriseInfo() {
                getInfoExtByEnterpriseId(this.baseInfo.enterpriseId).then((res) => {
                    if (res.status == 200 && res.data) {
                        this.enterpriseInfo = res.data;
                    }
                });
            },
            /** 查询当前登录用户的简历列表*/
            queryResumeList() {
                if (this.resumeList.length > 0) {
                    return;
                }
                getBaseInfoListByCreatorId().then((res) => {
                    if (res.status === 200 && res.data) {
                        this.resumeList = res.data;
                        for (let i = 0; i < this.resumeList.length; i++) {
                            if (
                                this.resumeList[i].defaultFlag &&
                                this.resumeList[i].defaultFlag === true
                            ) {
                                this.defaultFlagForm.resumeId = this.resumeList[i].id;
                                this.defaultFlagForm.defaultFlag = true;
                            }
                        }
                    }
                });
            },
            /** 检查当前用户是否已经投递此职位*/
            checkUserIdIsInJobPositionApplyRecord(jobId) {
                checkUserIdIsInJobPositionApplyRecord(jobId).then((res) => {
                    if (res.status == 200 && res.data) {
                        this.hasBeenPosting = res.data;
                    }
                });
            },
            // 投递简历
            handlePush() {
                if (!this.Cookies.get("TipDM-Login-Token")) {
                    // 跳转到登录页面
                    window.location.href = this.loginUrl;
                } else {
                    // 查询当前用户简历列表
                    this.queryResumeList();
                    this.form = Object.assign({}, this.defaultFlagForm);
                    // 打开弹窗
                    this.submitResumeDialog = true;
                }
            },
            // 薪酬
            salaryFormatter(data) {
                if (!data) {
                    return "";
                }
                if (data.payMethod == FACE_TO_FACE_WAGES) {
                    return '面议';
                }
                let str = data.minimumWage;
                if (data.maximumWage) {
                    str = str + " - " + data.maximumWage;
                }
                switch (data.payMethod) {
                    case YEAR_WAGES:
                        str += "•年";
                        break;
                    case MONTHLY_WAGES:
                        str += "•月";
                        break;
                    case DAILY_WAGES:
                        str += "•日";
                        break;
                    case HOURLY_WAGES:
                        str += "•时";
                        break;
                }
                return str;
            },
            // 工作地区
            // enterpriseAddressFormatter(data) {
            //     return "";
                //                 if (!data) {
                //                     return '';
                //                 }else {
                //
                //
                //                     let city = data.enterpriseAddress;
                // //                    return city;
                //                     return JSON.parse(data.enterpriseAddress.city).join('');
                //                 }
            // },
            // 工作地点
            workplaceFormatter(data) {
                let city = "";
                let detailedAddress = "";
                try {
                    city = JSON.parse(data.enterpriseAddress.city).join("");
                } catch (e) {
                    city = "";
                }
                if (data.enterpriseAddress && data.enterpriseAddress.detailedAddress) {
                    detailedAddress = data.enterpriseAddress.detailedAddress;
                }
                return city + detailedAddress;
            },
            // 人数
            countFormatter(data) {
                if (!data) {
                    return "";
                }
                if (data.count == 0 || data.count == "0") {
                    return "人数不限";
                } else {
                    return data.count;
                }
            },
            // 时间是否超过当前时间
            isEnd(date) {
                if (!date) {
                    return false;
                }
                return new Date() > moment(date);
            },
            // 日期格式化
            dateFormatter(date) {
                if (!date) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            // 时间格式化
            timeFormatter(date) {
                if (!date) {
                    return "";
                }
                return moment(date).format("HH:mm");
            },
            imgHandle(path) {
                if (path) {
                    return "http://localhost:20013/files?imagePath=" + path;
                }
            },
            // 投递简历
            submitResume(form) {
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        let resumeId = this.form.resumeId;
                        let jobPositionId = this.jobId;
                        let enterpriseId = this.baseInfo.enterpriseId;

                        if (!jobPositionId || !enterpriseId) {
                            this.msgError("投递失败，数据有误！");
                            return false;
                        }
                        saveResumeDeliveryRecord({
                            resumeId: resumeId,
                            jobPositionId: jobPositionId,
                            positionName: this.baseInfo.positionName,
                            enterpriseId: enterpriseId,
                            enterpriseName: this.baseInfo.enterpriseName,
                        }).then((res) => {
                            this.updateResumeDefaultFlag();
                            this.msgSuccess("投递成功");
                            this.hasBeenPosting = true;
                            this.closeSubmitResumeDialog();
                        });
                    } else {
                        return false;
                    }
                });
            },
            // 修改默认简历
            updateResumeDefaultFlag() {
                updateResumeDefaultFlag(this.form).then((res) => {
                });
            },
            // 取消投递简历
            closeSubmitResumeDialog() {
                this.resetForm("submitResumeForm");
                // 关闭弹窗
                this.submitResumeDialog = false;
            },
            tagArrayToStr(data, sep) {
                data = JSON.parse(data);
                let result = "";
                if (!sep) {
                    sep = " ";
                }
                if (data && data instanceof Array) {
                    result = data.join(sep);
                }
                return result;
            },
            preText(pretext) {
                if (pretext) {
                    return pretext
                        .replace(/\r\n/g, "<br/>")
                        .replace(/\n/g, "<br/>")
                        .replace(/\s/g, "&nbsp;");
                } else {
                    return "";
                }
            },
        },
    };
</script>
<style lang="scss" scoped>
    .jobDetailsMain.moblie {
        padding: 0 12px;
        padding-top: 15px;

        .container {
            padding: 0;
            padding-top: 4px;

            .dateTime {
                text-align: center;
                margin: 0 auto;
                margin-top: 14px;
                width: 160px;

                > p {
                    display: flex;
                    justify-content: space-between;
                    font-size: 12px;
                    color: #cdd1de;

                    &:first-of-type {
                        margin-bottom: 6px;
                    }
                }
            }
        }

        .jobTit {
            border-radius: 10px;
        }

        .cBlock {
            margin-top: 0px;
            padding: 15px 0 18px 0;
            margin-bottom: 12px;
            border-radius: 6px;

            .tit {
                padding-top: 15px;
                border-radius: 6px 6px 0 0;
            }

            .tit h5 {
                padding-left: 12px;
                font-size: 16px;

                &::before {
                    width: 2px;
                }
            }

            .cTxt {
                padding: 15px 12px 12px 12px;
                line-height: 22px;
                border-radius: 0 0 6px 6px;
                margin-bottom: 12px;
            }
        }

        .compangDes {
            .cBlock {
                .tit {
                    padding-top: 0;
                }
            }
        }

        .companyIntro .property p {
        }

        .jobTit .sideInfo {
            position: fixed;
            display: block;
            left: 0;
            width: 100%;
            height: 52px;
            line-height: 40px;
            bottom: 0;
            left: 0;
            background: #fff;
            z-index: 999;
            padding: 8px 20px 4px;
            box-sizing: border-box;

            .dateTime {
                display: none;
            }

            ::v-deep .el-row {
                display: flex;
                justify-content: center;
            }

            ::v-deep .el-button.is-round {
                border-radius: 6px;
            }
        }

        ::v-deep .submit-resume {
            .el-popper {
                position: absolute !important;
                left: 0 !important;
                top: auto !important;
            }

            .el-dialog__body {
                padding-bottom: 50px !important;
            }

            .el-select-dropdown__list {
                height: 95px;
                overflow: auto;
            }

            .el-select-dropdown__empty,
            .el-select-dropdown__item {
                height: 20px;
                line-height: 20px;
            }
        }
    }

    .ql-container.ql-snow {
        min-height: 200px;
        border: none;
    }
</style>
